
const routerSchema = {
  pathname: 'ui.history.currentLocation.pathname',
  search: 'ui.history.currentLocation.search',
  hash: 'ui.history.currentLocation.hash',
};

export default routerSchema;

